
$(document).ready(function(){
	$(window).scroll(function(){

		// IN HOME DESIGN
		if ($('.parallax-inHomeDesign').length > 0){
			// rotate details for fabric swatch 1
			var body = $(document.body);
			var bodyHeight = body.height();

			$(window).scroll(function () {
				$('#Design-element-1').css({
					'transform': 'rotate(' + ($(window).scrollTop() / bodyHeight * 550) + 'deg)'
				});
			});
			// rotate details for fabric swatch 2
			var body2 = $(document.body);
			var bodyHeight = body.height();

			$(window).scroll(function () {
				$('#Design-element-2').css({
					'transform': 'rotate(' + ($(window).scrollTop() / bodyHeight * 550) + 'deg)'
				});
			});
			var inHomeSection = $('.parallax-inHomeDesign').offset().top;
			if( ($(window).width() > 770) && ($(window).scrollTop() > inHomeSection - 200) ) {
				   $('Design-element-1').addClass("element1"); // fabric
				   $('Design-element-1').removeClass("element1_hide");
				   $('Design-element-2').addClass("element2"); // fabric
				   $('Design-element-2').removeClass("element2_hide");
			}
		}

		// MATTRESSES
		if ($('.parallax-Mattresses').length > 0){
			var  mattressSection = $('.parallax-Mattresses').offset().top;
			if(($(window).scrollTop() > mattressSection - 600) && ($(window).width() >= 360)) {
				   $('#Mattresses-element-1').addClass("element1"); // pillow
				   $('#Mattresses-element-1').removeClass("element1_hide");
				   $('#Mattresses-element-2').addClass("element2"); // teddybear
				   $('#Mattresses-element-2').removeClass("element2_hide");
				   $('#Mattresses-element-3').addClass("element3"); // child
				   $('#Mattresses-element-3').removeClass("element3_hide");
			} else {
				   $('#Mattresses-element-1').removeClass("element1"); // pillow
				   $('#Mattresses-element-1').addClass("element1_hide");
				   $('#Mattresses-element-2').removeClass("element2"); // teddybear
				   $('#Mattresses-element-2').addClass("element2_hide");
				   $('#Mattresses-element-3').removeClass("element3"); // child
				   $('#Mattresses-element-3').addClass("element3_hide");
			}
		}

		// STRESSLESS
		if ($('.parallax-Stressless').length > 0){
			var  stresslessSection = $('.parallax-Stressless').offset().top;
			if(($(window).scrollTop() > stresslessSection - 500) && ($(window).width() >= 1200)) {
				$('#Stressless-element-1').addClass("element1"); // furniture
				$('#Stressless-element-1').removeClass("element1_hide");
			} else {
				$('#Stressless-element-1').removeClass("element1"); // furniture
				$('#Stressless-element-1').addClass("element1_hide");
			}
		}

		// FLOORING
		if ($('.parallax-Flooring').length > 0){
			var  flooringSection = $('.parallax-Flooring').offset().top;
			if( ($(window).width() >= 1200) && ($(window).scrollTop() > flooringSection - 500) ) {
				   $('#Flooring-element-1').addClass("element1"); // bottom right grey carpet
				   $('#Flooring-element-1').removeClass("element1_hide");
				   $('#Flooring-element-2').addClass("element2"); // bottom left white carpet
				   $('#Flooring-element-2').removeClass("element2_hide");
				   $('#Flooring-element-3').addClass("element3"); // top right wood
				   $('#Flooring-element-3').removeClass("element3_hide");
				   $('#Flooring-element-4').addClass("element4"); // top left grey tiles
				   $('#Flooring-element-4').removeClass("element4_hide");
			} else {
				   $('#Flooring-element-1').removeClass("element1"); // bottom right grey carpet
				   $('#Flooring-element-1').addClass("element1_hide");
				   $('#Flooring-element-2').removeClass("element2"); // bottom left white carpet
				   $('#Flooring-element-2').addClass("element2_hide");
				   $('#Flooring-element-3').removeClass("element3"); // top right wood
				   $('#Flooring-element-3').addClass("element3_hide");
				   $('#Flooring-element-4').removeClass("element4"); // top left grey tiles
				   $('#Flooring-element-4').addClass("element4_hide");
			}
		}
	});
	// SIGN-IN PAGE
	if ($('.parallax-Autoscroll').length > 0 && document.documentElement.clientWidth > 1280){
		var img = new Image;
		img.src = $('.parallax-Autoscroll').css('background-image').match(/^url\("?(.+?)"?\)$/)[1];
		var bgImgHeight = img.height;
		$('.parallax-Autoscroll').css("background-position-y", bgImgHeight + "px");
		var animateBackground = setInterval(function(){
			if ($('.parallax-Autoscroll').css("background-position-y").replace("px","") > 0){
				$('.parallax-Autoscroll').css("background-position-y","-=1px");
			} else {
				$('.parallax-Autoscroll').css("background-position-y",bgImgHeight + "px");
			}
		},50);
	}
});
